import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Drawer,
  IconButton,
  Typography,
} from '@mui/material';
import { Item } from '../../utils/sharedTypes';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import useStyles from '../orders/orderLinkedItemsStyles';
import React, { useEffect, useState } from 'react';
import HardwareDisplayForDepartments from './HardwareDisplayForDepartments';
import {
  useFindAllLicensesByCompanyIdQuery,
  useFindOneDepartmentQuery,
} from '../../api/api-hooks';
import { License } from '../../api/api-generated';
import HardwareDisplayForUnlinkedLicenses from './HardwareDisplayForUnlinkedLicenses';

interface Props {
  departments: Item[];
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  companyId: number;
}

const PlansLinkedItemsDisplay = ({
  companyId,
  departments,
  open,
  setOpen,
}: Props) => {
  const { data: companyLicenses } = useFindAllLicensesByCompanyIdQuery({
    id: companyId,
  });
  const [companyLicensesNoDepartment, setCompanyLicensesNoDepartment] =
    useState<License[]>([]);
  useEffect(() => {
    if (companyLicenses) setCompanyLicensesNoDepartment(companyLicenses);
  }, [companyLicenses]);
  const classes = useStyles();
  const { data: department } = useFindOneDepartmentQuery(
    {
      id: departments[0]?.id ? departments[0].id : -1,
    },
    { refetchOnMountOrArgChange: true }
  );
  if (!department || departments.length === 0)
    return (
      <Drawer
        anchor='right'
        variant='persistent'
        open={open}
        className={classes.drawer}
        classes={{ paper: classes.drawerPaper }}
      >
        <div className={classes.drawerHeader}>
          <IconButton
            onClick={() => {
              setOpen(false);
            }}
            size='large'
          >
            <ChevronRight />
          </IconButton>
        </div>
        <Typography>No department selected.</Typography>
      </Drawer>
    );

  return (
    <Drawer
      anchor='right'
      variant='persistent'
      open={open}
      className={classes.drawer}
      classes={{ paper: classes.drawerPaper }}
    >
      <div className={classes.drawerHeader}>
        <IconButton
          onClick={() => {
            setOpen(false);
          }}
          size='large'
        >
          <ChevronRight />
        </IconButton>
      </div>
      {departments.length > 1 ? (
        <Typography>Multiple departments selected.</Typography>
      ) : (
        <>
          <Accordion square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Typography>Department Licenses</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {department.hardware.some((item) => item.licenses.length > 0) ? (
                <HardwareDisplayForDepartments department={department} />
              ) : (
                <Typography>
                  No software licenses linked to Department.
                </Typography>
              )}
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Typography>Licenses With No Department</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {companyLicensesNoDepartment.length > 0 ? (
                <HardwareDisplayForUnlinkedLicenses
                  licenses={companyLicensesNoDepartment}
                />
              ) : (
                <Typography>No licenses found.</Typography>
              )}
            </AccordionDetails>
          </Accordion>
          <Divider />
        </>
      )}
    </Drawer>
  );
};

export default PlansLinkedItemsDisplay;
